export const Colors = {
  KIHADA: "#FBE251",
  TOHOH: "#FFC408",
  YAMABUKI: "#FFB11B",
  OHNI: "#F05E1C",
  WHITE: "#FFFFFF",
  BLACK: "#000000",
};
